import React from 'react';
import PropTypes from 'prop-types';
import Grid from 'styled-components-grid';
import CollectorCheckout from 'collector-checkout';
import {Card} from "../../../styledComponents";

const development = process.env.REACT_APP_DEVELOPMENT;


class Collector extends React.Component {
    state = {
        dataType: 'B2C',
        disableInput: false
    };

    changeDataType = (dataType) => {
        this.setState({dataType})
    };

    orderStatus = (status) => {
        if (status === 'locked') {
            this.setState({ disableInput: true });
        }
    };


    render() {
        const {dataType, disableInput} = this.state;
        const {tokens} = this.props;
        const token = tokens[dataType];


        return (
            <Card
                title="Betala er bokning">
                <Grid>
                    <Grid.Unit size={1}>
                        <label>
                            <input
                                type="radio"
                                value="B2C"
                                checked={dataType === 'B2C'}
                                onChange={e => this.changeDataType(e.target.value)}
                                disabled={disableInput}
                            />
                            {' Betala som privatperson'}
                        </label>
                    </Grid.Unit>
                    <Grid.Unit size={1}>

                        <label>
                            <input
                                type="radio"
                                value="B2B"
                                checked={dataType === 'B2B'}
                                onChange={e => this.changeDataType(e.target.value)}
                                disabled={disableInput}
                            />
                            {' Betala som företag'}
                        </label>
                    </Grid.Unit>
                    <Grid.Unit size={1}>
                        <CollectorCheckout
                            dataType={dataType}
                            token={tokens[dataType]}
                            nodeRef={node => console.log(node)}
                            development={development === 'true'}
                            checkoutUpdate={update => this.orderStatus(update)}
                        />
                    </Grid.Unit>
                </Grid>
            </Card>
        )

    }


}


export default Collector;



// WEBPACK FOOTER //
// ./src/components/Confirmation/components/Collector.jsx